import React, { useState, useEffect } from 'react'
import { SubmitHandler, useForm, UseFormReturn } from 'react-hook-form'
import { BodyParams, ErrorBoxComponent, FieldProps, FormDataBase, FormWrapper, onSubmit } from '../common/FormBase'
import { emailField, idField, langField, passwordField, phoneNumberField, roleField, usernameField } from '../common/fields'

export interface UserFormData extends FormDataBase {
  id?: string
  lang: string
  username: string
  email: string
  phoneNumber: string
  password: string
  passwordRepeat: string
}

export interface NewPasswordFormData extends FormDataBase {
  password: string
  passwordRepeat: string
}

export interface UsersFormParams extends BodyParams<UserFormData>{
  onSubmit: onSubmit<UserFormData>
}

export const UserRegisterForm = (params: UsersFormParams) => {
  const formHandler: SubmitHandler<UserFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<UserFormData> {...params}  formName='user' onSubmit={formHandler}>
    {UserRegisterBody(params)}
  </FormWrapper>
}

export const UserRegisterBody = (params: BodyParams<UserFormData>) => {
  const fieldProps: FieldProps<UserFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {email({...fieldProps, readOnly: true})}
    {lang(fieldProps)}
    {username(fieldProps)}
    {phoneNumber(fieldProps)}
    {password(fieldProps)}
    {password({...fieldProps, fieldName: 'passwordRepeat'})}
  </>
}

export const SuperAdminEditUserForm = (params: UsersFormParams) => {
  const formHandler: SubmitHandler<UserFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<UserFormData> {...params} formName='user' onSubmit={formHandler}>
    {SuperAdminEditUserBody(params)}
  </FormWrapper>
}

export const SuperAdminEditUserBody = (params: BodyParams<UserFormData>) => {
  const fieldProps: FieldProps<UserFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {id(fieldProps)}
    {email(fieldProps)}
    {lang(fieldProps)}
    {username(fieldProps)}
    {phoneNumber(fieldProps)}
    {role(fieldProps)}
  </>
}

export const SuperAdminInsertUserForm = (params: UsersFormParams) => {
  const formHandler: SubmitHandler<UserFormData> = (data) => {
    if (data.password !== data.passwordRepeat) {
      params.form.setError('passwordRepeat', {
        type: 'validate',
        message: params.translate?.for('forms.user.errors.passwordMismatch'),
      })
      return
    }
    params.onSubmit(data);
  }
  return <FormWrapper<UserFormData> {...params} formName='user' onSubmit={formHandler}>
    {SuperAdminInsertUserBody(params)}
  </FormWrapper>
}

export const SuperAdminInsertUserBody = (params: BodyParams<UserFormData>) => {
  const fieldProps: FieldProps<UserFormData> = {
    ...params,
    fieldName: ''
  }
  return <>
    {id(fieldProps)}
    {email(fieldProps)}
    {lang(fieldProps)}
    {username(fieldProps)}
    {phoneNumber(fieldProps)}
    {password(fieldProps)}
    {passwordRepeat(fieldProps)}
    {role(fieldProps)}
  </>
}

export const SuperAdminNewPasswordBody = (params: BodyParams<NewPasswordFormData>) => {
  const fieldProps: FieldProps<NewPasswordFormData> = {
    ...params,
    formName: 'user',
    fieldName: ''
  }
  return <>
    {passwordField<NewPasswordFormData>()({...fieldProps, fieldName: 'password'})}
    {passwordField<NewPasswordFormData>()({...fieldProps, fieldName: 'passwordRepeat'})}
  </>
}

export interface NewPasswordFormParams extends BodyParams<NewPasswordFormData>{
  onSubmit: onSubmit<NewPasswordFormData>
}

export const SuperAdminNewPasswordForm = (params: NewPasswordFormParams) => {
  const formHandler: SubmitHandler<NewPasswordFormData> = (data) => {
    if (data.password !== data.passwordRepeat) {
      params.form.setError('passwordRepeat', {
        type: 'validate',
        message: params.translate?.for(`forms.${params.formName}.errors.passwordMismatch`),
      })
      return
    }
    params.onSubmit(data);
  }
  return <FormWrapper<NewPasswordFormData> {...params} formName={params.formName} onSubmit={formHandler}>
    {SuperAdminNewPasswordBody(params)}
  </FormWrapper>
}

export const id = (props: FieldProps<UserFormData>) => idField<UserFormData>()({...props, fieldName: props.fieldName || 'id', formName: props.formName || 'user'})
export const email = (props: FieldProps<UserFormData>) => emailField<UserFormData>()({...props, fieldName: props.fieldName || 'email', formName: props.formName || 'user'})
export const lang = (props: FieldProps<UserFormData>) => langField<UserFormData>()({...props, fieldName: props.fieldName || 'lang', formName: props.formName || 'user'})
export const username = (props: FieldProps<UserFormData>) => usernameField<UserFormData>()({...props, fieldName: props.fieldName || 'username', formName: props.formName || 'user'})
export const phoneNumber = (props: FieldProps<UserFormData>) => phoneNumberField<UserFormData>()({...props, fieldName: props.fieldName || 'phoneNumber', formName: props.formName || 'user'})
export const password = (props: FieldProps<UserFormData>) => passwordField<UserFormData>()({...props, fieldName: props.fieldName || 'password', formName: props.formName || 'user'})
export const passwordRepeat = (props: FieldProps<UserFormData>) => passwordField<UserFormData>()({...props, fieldName: props.fieldName || 'passwordRepeat', formName: props.formName || 'user'})
export const role = (props: FieldProps<UserFormData>) => roleField<UserFormData>()({...props, fieldName: props.fieldName || 'role', formName: props.formName || 'user'})